// Simple recaptcha utility - returns empty string if not configured
export const generateRecaptchaToken = async (action: string): Promise<string> => {
  try {
    // Check if grecaptcha is available (loaded via script tag)
    if (typeof window !== 'undefined' && (window as any).grecaptcha) {
      const siteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY;
      if (siteKey) {
        return await (window as any).grecaptcha.execute(siteKey, { action });
      }
    }
    return '';
  } catch (error) {
    console.warn('reCAPTCHA not configured or failed:', error);
    return '';
  }
};

